"use client"

import * as React from "react"
import { cn } from "../lib/utils.ts"
import { RadioGroup as RadioGroupPrimitive } from "radix-ui"

/* shadcn/ui RadioGroup, restyled like Checkbox: 16 px, a --border-control edge, the solid accent with a white centre when chosen. One of 2 to 5 inside a form, stacked, with a default. */
function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-2", className)}
      {...props}
    />
  )
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "group/radio inline-flex aspect-square size-4 shrink-0 items-center justify-center rounded-full border border-input bg-sunken transition-colors duration-(--duration-fast) ease-standard hover:border-fg-subtle disabled:cursor-not-allowed disabled:border-border-strong aria-invalid:border-status-danger data-[state=checked]:border-transparent data-[state=checked]:bg-(--control-mid) disabled:data-[state=checked]:border-border-strong disabled:data-[state=checked]:bg-active",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex items-center justify-center"
      >
        <span className="block size-1.5 rounded-full bg-(--control-fg) group-disabled/radio:bg-fg-faint" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
